import { SEARCH_PARAMS } from '@sorare/core/src/components/search/InstantSearch/types';
import { useConfigContext } from '@sorare/core/src/contexts/config';
import { useInSeasonLocalStorage } from '@sorare/core/src/hooks/search/useInSeasonLocalStorage';
import { useQueryString } from '@sorare/core/src/hooks/useQueryString';
import { useTitleAndDescription } from '@sorare/core/src/hooks/useTitleAndDescription';
import {
  SaleType,
  TOKENS_STACKED_LIMIT,
  createCardSorts,
} from '@sorare/core/src/lib/algolia';
import { TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';
import { metadatas } from '@sorare/core/src/lib/seo/football';

import { ManagersSales } from '@sorare/marketplace/src/components/market/OnboardingDialog/ManagersSales';
import { PageTemplate } from '@sorare/marketplace/src/components/market/PageTemplate';
import { useDefaultFilters } from '@sorare/marketplace/src/hooks/useDefaultFilters';
import { secondaryMarketFilters } from '@sorare/marketplace/src/searchCards/football/cardFilters';

import { FootballCardSearch } from 'components/searchCards/FootballCardSearch';
import { SelectedLeaderboardBanner } from 'components/searchCards/SelectedLeaderboardBanner';

const ManagerSalesPage = () => {
  useTitleAndDescription(
    metadatas.transfers.title,
    metadatas.transfers.description
  );
  const unstacked = useQueryString(SEARCH_PARAMS.UNSTACKED);
  const { algoliaCardIndexes } = useConfigContext();

  const displayStackedView = !unstacked;
  const [inSeason] = useInSeasonLocalStorage();

  const filters = useDefaultFilters({
    secondary: true,
    onlySettlableCards: true,
  });

  const cardSortsWithBestValue = createCardSorts({
    indexPrefix: 'Cards On Sale',
    withBestValue: true,
    withHighestPrice: false,
    withHighestAverageScore: true,
    withPopularPlayer: true,
    withEndingSoon: false,
  });

  return (
    <PageTemplate showBack>
      <ManagersSales />
      <FootballCardSearch
        defaultHitsPerPage={40}
        cardFilters={secondaryMarketFilters}
        analyticsTags={['TransferMarket', 'Football']}
        sorts={cardSortsWithBestValue}
        defaultSort="Cards On Sale Popular Player"
        defaultFilters={filters}
        removeEndedSingleSaleOffers
        initialIndexUIState={{
          ...(displayStackedView && {
            toggle: {
              [TOGGLE_FILTERS.inSeasonFilter.attribute]: inSeason,
            },
          }),
          sortBy: displayStackedView
            ? algoliaCardIndexes['Cards On Sale Popular Player']
            : algoliaCardIndexes['Cards On Sale Newly Listed'],
        }}
        distinct={displayStackedView ? TOKENS_STACKED_LIMIT : false}
        stackableTypes={[SaleType.SINGLE_SALE_OFFER]}
        attributesToRetrieve={[
          'asset_id',
          'sale',
          'player',
          'rarity',
          'season',
          'slug',
        ]}
        banner={<SelectedLeaderboardBanner />}
        displayVideoTutorial
      />
    </PageTemplate>
  );
};

export default ManagerSalesPage;
